document.addEventListener('DOMContentLoaded', function() {
  console.log('Dropdown hover script loaded');
  console.log('Window width:', window.innerWidth);
  
  if (window.innerWidth < 990) {
    console.log('Skipping - mobile view');
    return;
  }
  
  // Target the details elements in the header menu
  const headerMenus = document.querySelectorAll('header-menu details[id^="Details-HeaderMenu-"]');
  console.log('Found header menus:', headerMenus.length);
  
  headerMenus.forEach(function(details) {
    const summary = details.querySelector('summary');
    
    if (!summary) return;
    
    let hoverTimeout;
    
    // Open on hover
    details.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        details.dispatchEvent(new Event('toggle'));
      }
    });
    
    // Close on mouse leave with slight delay
    details.addEventListener('mouseleave', function() {
      hoverTimeout = setTimeout(function() {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          details.dispatchEvent(new Event('toggle'));
        }
      }, 100);
    });
    
    // Prevent the focusout close when hovering
    details.addEventListener('focusout', function(e) {
      if (details.matches(':hover')) {
        e.stopImmediatePropagation();
      }
    }, true);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 990) return; // Desktop only
  
  const headerMenus = document.querySelectorAll('header-menu');
  
  headerMenus.forEach(function(menu) {
    const details = menu.querySelector('details');
    const summary = details?.querySelector('summary');
    
    if (!details || !summary) return;
    
    let hoverTimeout;
    
    // Open on hover
    menu.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        details.dispatchEvent(new Event('toggle'));
      }
    });
    
    // Close on mouse leave with slight delay
    menu.addEventListener('mouseleave', function() {
      hoverTimeout = setTimeout(function() {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          details.dispatchEvent(new Event('toggle'));
        }
      }, 100);
    });
    
    // Prevent the focusout close when hovering
    details.addEventListener('focusout', function(e) {
      if (menu.matches(':hover')) {
        e.stopImmediatePropagation();
      }
    }, true);
  });
});
document.addEventListener('DOMContentLoaded', function() {
  console.log('Dropdown hover script loaded');
  console.log('Window width:', window.innerWidth);
  
  if (window.innerWidth < 990) {
    console.log('Skipping - mobile view');
    return;
  }
  
  const headerMenus = document.querySelectorAll('header-menu');
  console.log('Found header menus:', headerMenus.length);
  
  headerMenus.forEach(function(menu) {
    const details = menu.querySelector('details');
    const summary = details ? details.querySelector('summary') : null;
    
    if (!details || !summary) return;
    
    let hoverTimeout;
    
    menu.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        details.dispatchEvent(new Event('toggle'));
      }
    });
    
    menu.addEventListener('mouseleave', function() {
      hoverTimeout = setTimeout(function() {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          details.dispatchEvent(new Event('toggle'));
        }
      }, 100);
    });
    
    details.addEventListener('focusout', function(e) {
      if (menu.matches(':hover')) {
        e.stopImmediatePropagation();
      }
    }, true);
  });
});

// Video click-to-play handler
document.addEventListener('DOMContentLoaded', function() {
  var thumb = document.getElementById('videoThumb');
  var video = document.getElementById('vid');
  
  if (thumb && video) {
    thumb.addEventListener('click', function() {
      thumb.style.display = 'none';
      video.style.display = 'block';
      video.play();
    });
    
    // Show cover image again when video ends
    video.addEventListener('ended', function() {
      video.style.display = 'none';
      thumb.style.display = 'block';
      video.currentTime = 0; // Reset video to beginning
    });
  }
});